import { useSelector } from "react-redux";
import { ReducerType } from "../../storeManager/ReducerType";
import { LoginInterface } from "../../Interfaces/LoginInterface";
import { SecondaryLayout } from "../../share/Components";

const Support = () => {
    const user = useSelector<ReducerType, LoginInterface>(
        (state) => state.reducerUser
    )
    return <div className="h-screen w-full">
        <iframe className="w-full h-[calc(100%_-_41px)]"
            allowFullScreen allow="microphone *;"
            src={`${window.env.App_Rayteb_Support}/user-support?personCode=${user.userData?.code}&fullName=${user.userData?.firstName + ' ' + user.userData?.lastName}&phoneNumber=${user.userData?.mobile}&channelId=1&urlRequest=${window.location.origin}`} />
    </div>
}

Support.Layout = function ({ children }) {
    return <SecondaryLayout title={'پشتیبانی آنلاین'}>{children}</SecondaryLayout>
}
export default Support;